// extracted by mini-css-extract-plugin
export default {"menuItemContent":"style_menuItemContent__mq9QN"};